import update from "immutability-helper";
import moment from "moment";
import {
  LAST_UPDATE_FORMAT,
  FETCH_INFO_INTERVENTO_SUCCESS,
  RESET_INFO_INTERVENTO,
  START_POLLING,
  STOP_POLLING,
  UPDATE_TIME_INFO,
  INCREMENT_CALL_NUMBER,
  RESET_FETCH_INFO_INTERVENTO_ENDED,
  SALVA_INFO_STRUTTURA,
  SET_RICERCA_EFFETTUATA,
} from "./index";

export const initialState = {
  infoStruttura: null,
  infoIntervento: {
    data: null,
    fetchEnded: false,
    callNumber: 0,
    pollingStarted: false,
    lastUpdate: null,
  },
  ricercaEffettuata: false,
};

const fetchInfoInterventoSuccessHandler = (state, action) => {
  let infoInterventoUpdated = Object.assign({}, state.infoIntervento);
  infoInterventoUpdated.data = action.infoIntervento;
  infoInterventoUpdated.fetchEnded = true;
  infoInterventoUpdated.callNumber = initialState.infoIntervento.callNumber;
  return update(state, {
    infoIntervento: { $set: infoInterventoUpdated },
  });
};

const resetInfoInterventoHandler = (state) => {
  return update(state, {
    infoIntervento: { $set: initialState.infoIntervento },
  });
};

const startPollingHandler = (state) => {
  let infoInterventoStarted = Object.assign({}, state.infoIntervento);
  infoInterventoStarted.pollingStarted = true;
  return update(state, {
    infoIntervento: { $set: infoInterventoStarted },
  });
};

const stopPollingHandler = (state) => {
  let infoInterventoStarted = Object.assign({}, state.infoIntervento);
  infoInterventoStarted.pollingStarted = false;
  return update(state, {
    infoIntervento: { $set: infoInterventoStarted },
  });
};

const updateTimeInfoHandler = (state) => {
  let infoInterventoUpdated = Object.assign({}, state.infoIntervento);
  infoInterventoUpdated.lastUpdate = moment().format(LAST_UPDATE_FORMAT);
  return update(state, {
    infoIntervento: { $set: infoInterventoUpdated },
  });
};

const incrementCallNumberHandler = (state) => {
  return update(state, {
    infoIntervento: {
      callNumber: { $set: state.infoIntervento.callNumber + 1 },
    },
  });
};

const resetFetchInfoInterventoEndedHandler = (state) => {
  let infoInterventoStarted = Object.assign({}, state.infoIntervento);
  infoInterventoStarted.fetchEnded = false;
  return update(state, {
    infoIntervento: { $set: infoInterventoStarted },
  });
};

const salvaInfoStrutturaHandler = (state, action) => {
  const { idEnte, idStruttura } = action;
  return update(state, {
    infoStruttura: { $set: { idEnte: idEnte, idStruttura: idStruttura } },
  });
};

const ricercaEffettuataHandler = (state, action) => {
  return update(state, {
    ricercaEffettuata: { $set: action.value },
  });
};

const rehydrateStoreHandler = (state, action) => {
  if (action.payload !== undefined) {
    let infoInterventoPersist = action.payload.surgery;
    infoInterventoPersist.infoIntervento.pollingStarted = false;
    infoInterventoPersist.infoStruttura = null;
    return update(state, { $set: infoInterventoPersist });
  } else return state;
};

export const surgeryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INFO_INTERVENTO_SUCCESS:
      return fetchInfoInterventoSuccessHandler(state, action);
    case RESET_INFO_INTERVENTO:
      return resetInfoInterventoHandler(state);
    case START_POLLING:
      return startPollingHandler(state, action);
    case STOP_POLLING:
      return stopPollingHandler(state);
    case UPDATE_TIME_INFO:
      return updateTimeInfoHandler(state, action);
    case INCREMENT_CALL_NUMBER:
      return incrementCallNumberHandler(state);
    case RESET_FETCH_INFO_INTERVENTO_ENDED:
      return resetFetchInfoInterventoEndedHandler(state);
    case SALVA_INFO_STRUTTURA:
      return salvaInfoStrutturaHandler(state, action);
    case SET_RICERCA_EFFETTUATA:
      return ricercaEffettuataHandler(state, action);
    case "persist/REHYDRATE":
      return rehydrateStoreHandler(state, action);
    default:
      return state;
  }
};
